<template>
    <div class="cup-playoff-matches">
        <div v-if="!stageGroup || !stageGroup.games || stageGroup.games.length === 0" class="no-games">
            <div class="no-games-icon">🏆</div>
            <h3>Матчи не найдены</h3>
            <p>Для выбранного сезона матчи этого этапа еще не добавлены</p>
        </div>

        <div v-else class="playoff-stage" :class="{ 'semifinal-stage': stageGroup.stage === 'semifinal' }">
            <!-- <h3 v-if="stageGroup.stage_name" class="stage-title">{{ stageGroup.stage_name }}</h3> -->
            <div class="matches-list" :class="{ 'matches-grid': stageGroup.stage === 'semifinal' }">
                <playoff-match v-for="game in stageGroup.games" :key="game.id" :game="game"
                    :centered="stageGroup.games.length === 1" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import PlayoffMatch from '@/components/features/results/PlayoffMatch.vue';

const props = defineProps({
    playoffGames: {
        type: Array,
        default: () => []
    }
});

// Ожидаем массив с одним этапом: [{ stage: '...', games: [...] }]
const stageGroup = computed(() => {
    if (!props.playoffGames || props.playoffGames.length === 0) return null;

    const first = props.playoffGames[0];
    if (first && Array.isArray(first.games)) {
        return first;
    }

    return null;
});
</script>

<style lang="scss" scoped>
.no-games {
    text-align: center;
    padding: 4rem 2rem;
    color: #64748b;

    .no-games-icon {
        font-size: 4rem;
        margin-bottom: 1rem;
    }

    h3 {
        font-size: 1.5rem;
        font-weight: 600;
        color: #1e293b;
        margin-bottom: 0.5rem;
    }

    p {
        font-size: 1rem;
        color: #64748b;
    }
}
</style>
